import { Component, OnInit, Input, ViewChild, TemplateRef, Output, EventEmitter, OnDestroy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
//import { Observable } from 'rxjs/Observable';
//import { Store } from '@ngrx/store';
import { CommonService} from '../../../services/index';
import { ToasterService } from 'angular2-toaster';
import { Observable } from 'rxjs/Observable';
import swal from 'sweetalert2';
import * as _ from 'lodash';

import { ClientWalkInService, TestingBillService } from '../../../services/index';
//import { ClientWalkInModel } from '../../../model/index';
//import { clientOutComponent } from '../../common/clientOut.component';

@Component({
    selector: 'test-bill-generation-window',
    templateUrl: './testBillGeneration.component.html'
})
export class TestBillGenerationComponent implements OnInit {

    isLoadMask: Promise<any>;
    public testBillDet: any[] = [];
    pocList: any[];
    pocCusCtrl: FormControl;
    isLoading: boolean = false;
    @Input() set clientWalkInDet(val: any[]) {
        if (val) {
            this.testBillDet = val;
            this.testBillDet['poc'] = [];
            if (this.testBillDet['test_type_id']) {
                const pocIds = this.testBillDet['test_type_id'].toString();
                if (pocIds.indexOf(',') > 0) {
                    const pocIdList = pocIds.split(',').map(function (item) {
                        return item;
                    });
                    this.testBillDet['poc'] = pocIdList;
                } else {
                    this.testBillDet['poc'] = [pocIds];
                }
                this.getTestingFees(pocIds);
            }
            this.loadPocList(val['status']);
        }
        this.testBillDet['hasPrograming'] = (val['status'] ? (val['status'].toLowerCase() == 'programing' || val['status'].toLowerCase() == 'programming') : false) || (val['test_name'] ? val['test_name'].toLowerCase() == 'programming' : false);
    }
    srcList: any[] = [];
    filteredSrc: Observable<any[]>;
    srclistCtrl: FormControl;
    @Output() walkInTestBillEvent = new EventEmitter();

    // clientWalkInData: ClientWalkInModel[];
    // loadingIndicator: boolean = true;
    // page = {
    //     limit: 25,
    //     count: 0,
    //     offset: 0,
    //     orderBy: 'date',
    //     orderDir: 'asc'
    // };
    // @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    // @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    // @ViewChild('filterPanel') filterPanel;
    // columns = [];
    // toggleCol = [];
    // filterData = {
    //     "search_data": ""
    // };
    // scrollTimeout: any;
    // suppressPaging: boolean = false;
    billType=['CASH', 'CARD', 'CHEQUE', 'ONLINE', 'CASH&CARD','CREDIT'];
    constructor(public bsModalRef: BsModalRef, public toasterService: ToasterService,private commonService: CommonService, private walkInService: ClientWalkInService, private testingBillService: TestingBillService) {
        function hasSrc(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidSRC: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidSRC: true };
            }
            return retVal;
        }
        this.srclistCtrl = new FormControl('', [
            Validators.required,
            hasSrc.bind(this)
        ]);
        //  this.halistCtrl = new FormControl();
        this.filteredSrc = this.srclistCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterSrc(name) : this.srcList.slice());
        this.pocCusCtrl = new FormControl();
    }

    ngOnInit(): void {
        let that = this;
        this.loadSrcList();
    }
    ngOnDestroy() {
    }

    loadSrcList () {
        let that = this,
            data = {
                name: ''
            };
        this.commonService
            .getBankLedger(data)
            .then(function (res: any) {
                that.srcList = res['data'];
                // that.actSerialNoList = res['haModelStockSerial'];
                that.srclistCtrl.setValue(that.testBillDet['bank']);
                //that.srclistCtrl.setValue(that.clientInData['bank_name']);
                //that.emplist2Ctrl.setValue(that.clientFollowDet['empid']);
            });
    }

    loadPocList(status) {
        let that = this;
        let data = {
            pov_name: status
        };
        this.pocList = [];
        const pocIds = this.pocCusCtrl.value;
        this.commonService
            .getPocListByPov(data)
            .then(function (res: any) {
                if (res && res.data && res.data.length) {
                    that.pocList = res.data;
                    if (pocIds && pocIds.length) {
                        that.pocCusCtrl.setValue(pocIds.filter(pocId => that.pocList.findIndex(poc => poc.id === pocId) < 0));
                    }
                } else {
                    that.pocCusCtrl.setValue([]);
                }
            });
    }
    displayPocFun(pocID: any) {
        if (this.pocList != undefined) {
            if (pocID && this.pocList.length > 0) {
                let fitem = _.find(this.pocList, { 'id': pocID });
                return fitem['name'];
            }
        }
        return '';
    }

    filterSrc(bank_name: string) {
        bank_name = _.escapeRegExp(bank_name);
        return this.srcList.filter(ha => (new RegExp(bank_name, 'gi').test(ha.bank)
            || new RegExp(bank_name, 'gi').test(ha.bank_name)));
    }

    displaySrc(item_id: number) {

        if (item_id && this.srcList.length > 0) {
            let fhalist = _.find(this.srcList, { 'bank': item_id }),
                bank_name = fhalist.bank_name;
                this.testBillDet['bank_name'] = bank_name;
            //this.challangriddata['avail_qty'] = fhalist.avail_qty;
            //  this.getModelSerialNo(item_id);
            return fhalist['bank_name'];
        }
        return '';
    }
    calGrantTotal() {
        let test_fee = this.testBillDet['test_fee'],
            dis_amt = this.testBillDet['dis_amt'],
            grant_total = test_fee;

        if (!_.isEmpty(_.toString(dis_amt))) {
            grant_total = test_fee - dis_amt;
        }

        this.testBillDet['grand_tot'] = grant_total;
    }
    getTestingFees(pocIds: string): void {
        let that = this;
        this.isLoading = true;

        this.testingBillService
            .getTestingFees({'pocIds': pocIds})
            .then(function(res: any) {
                that.isLoading = false;
                if (res && res.data && res.data.length) {
                    that.testBillDet['test_type_desc'] = res.data[0].test_type_desc;
                    that.testBillDet['test_fee'] = parseFloat(res.data[0].fees);
                } else {
                    that.testBillDet['test_type_desc'] = '';
                    that.testBillDet['test_fee'] = 0;
                }
                that.testBillDet['grand_tot'] = that.testBillDet['test_fee'];
            });
    }
    onSaveBillGen(): void {
        let that = this,
        cash_amount = this.testBillDet['cash_amt'],
        card_amount = this.testBillDet['card_amt'],
        total_amt = this.testBillDet['grand_tot'];
       
        if (this.testBillDet['type'] == 'CASH&CARD') {
            let tot = parseFloat(cash_amount) + parseFloat(card_amount);
          
                if (total_amt != tot) {
                    swal('WARNING', 'Amount Does Not Match!!!');
                    return;
                }   
           
        }
        this.isLoading = true;

        this.walkInService
            .saveTestBillGeneration(this.testBillDet)
            .then(function(res: any) {
                that.isLoading = false;
                if (res.success) {
                    that.bsModalRef.hide();
                    that.walkInTestBillEvent.emit();
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };
                    that.toasterService.pop(toast);
                }
            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/clientWalkIn/testBillGeneration.component.ts